module.exports = __webpack_public_path__ + "img/lover of sweets.a18465a2.png";